export const GET_WTF_WORKFLOW_QUERY = `query getWorkflowList($limit: Int, $offset: Int, $course_id: Int!, $searchExpression: [wft_workflow_bool_exp!], $conditions: wft_workflow_bool_exp = {}) {
  wft_workflow(limit: $limit, offset: $offset, where: { _and: [{_or: $searchExpression}, $conditions, { course_id: { _eq: $course_id } }]}) {
    id
    status
    title
    steps {
      name
      id
    }
    updated_at
    updated_by
    updated_by_details {
      email
      name
      id
    }
    course {
      id
      name
    }
    drive_schedule {
      sku {
        price
        currency_code
      }
    }
  }
  wft_workflow_aggregate (where: { _and: [{_or: $searchExpression}, $conditions, { course_id: { _eq: $course_id } }]}) {
    aggregate {
      count
    }
  }
}`;

export const GET_WTF_CANDIDATE_LIST_QUERY = `query getWorkflowCandidateList ($conditions: wft_workflow_candidate_bool_exp = {}){
  wft_workflow_candidate (where: { _and: [$conditions]}){
    candidate {
      first_name
      id
      last_name
      middle_name
      email
      external_id
    }
    workflow_candidate_steps {
      step_id
      step {
        name
        id
      }
      session_uuid
    }
    workflow {
      title
      course {
        name
        id
      }
    }
  }
}`;
